var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18.379,
    viewBox: "0 0 14 18.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-forms",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M74.842,4.465,70.535.158A.542.542,0,0,0,70.154,0H62.615A1.617,1.617,0,0,0,61,1.615V16.764a1.617,1.617,0,0,0,1.615,1.615H73.385A1.617,1.617,0,0,0,75,16.764V4.846A.544.544,0,0,0,74.842,4.465Zm-4.15-2.627,2.469,2.469H71.231a.539.539,0,0,1-.538-.538ZM73.385,17.3H62.615a.539.539,0,0,1-.538-.538V1.615a.539.539,0,0,1,.538-.538h7V3.769a1.617,1.617,0,0,0,1.615,1.615h2.692V16.764A.539.539,0,0,1,73.385,17.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M187.318,242h-5.744a.574.574,0,1,0,0,1.149h5.744a.574.574,0,0,0,0-1.149Z",
    transform: "translate(-115.938 -233.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(63.351 8.605)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M187.318,302h-5.744a.574.574,0,1,0,0,1.149h5.744a.574.574,0,1,0,0-1.149Z",
    transform: "translate(-115.938 -291.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(63.351 10.605)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M187.318,362h-5.744a.574.574,0,1,0,0,1.149h5.744a.574.574,0,1,0,0-1.149Z",
    transform: "translate(-115.938 -349.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(63.351 12.605)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleForms);
export default __webpack_public_path__ + "static/media/google-forms.366a803d.svg";
export { ForwardRef as ReactComponent };